import { FaRegCommentDots } from "react-icons/fa";
import Collabse from "../../../components/Collabse";
import { useAppSelector } from "../../../redux/store";
import ItemRemarks from "./ItemRemarks";
import NoRemarksMessage from "./NoRemarksMessage";
import { useTranslation } from "react-i18next";

const Remarks = () => {
  const booking = useAppSelector((state) => state.booking);
  const remarks = booking.bookingRemarks;
  const { t } = useTranslation();

  return (
    <Collabse Header={Header}>
      <div className="ms-4 me-4">
        <NoRemarksMessage />

        {remarks?.map((remark, i: any) => {
          return (
            <div key={i} className="mb-4">
              <p>
                <strong>{remark.itemType}: </strong>
              </p>
              <ItemRemarks itemRemarks={remark.itemRemarks} />
            </div>
          );
        })}
      </div>
    </Collabse>
  );
};

const Header = () => {
  const { t } = useTranslation();

  return (
    <h5>
      <FaRegCommentDots />
      {t("bookingDetails.remarks.title")}
    </h5>
  );
};

export default Remarks;
